import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from 'react-bootstrap/Navbar'
import Jumbotron from 'react-bootstrap/Jumbotron'
import bootstrapContainer from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import jumboUrl from './images/Jumbo01.jpg'
import navBarUrl from './images/Bar01.jpg'


function calculateWinner(squares) {
    const lines = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [0, 3, 6],
        [1, 4, 7],
        [2, 5, 8],
        [0, 4, 8],
        [2, 4, 6],
    ];
    for (let i = 0; i < lines.length; i++) {
        const [a, b, c] = lines[i];
        if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
            return squares[a];
        }
    }
    return null;
}

function Square(props) {
    return (
        <button
            className="square"
            onClick={props.onClick}
        >
            {props.value}
        </button>
    );
}
  
class Board extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            squares: Array(9).fill(null),
            xIsNext: true,
        }
    }
    renderSquare(i) {
        return (
            <Square
                value={this.props.squares[i]}
                onClick={() => this.props.onClick(i)}
            />
        );
    }
    renderRows(fromN){
        return (
            <div>
                <div className="board-row">
                    {this.renderSquare(fromN)}
                    {this.renderSquare(fromN+1)}
                    {this.renderSquare(fromN+2)}
                </div>
            </div>
        )
    }
    render() {
        return (
            <div>
                {this.renderRows(0)}
                {this.renderRows(3)}
                {this.renderRows(6)}
            </div>
        );
    }
}
  
class Game extends React.Component {
    constructor(props){
        super(props);
        this.state ={
            history: [{
                squares: Array(9).fill(null),
            }],
            stepNumber: 0,
            xIsNext: true,
            contentsNumber: 0
        }
    }
    handleClick(i){
        const history = this.state.history.slice(0, this.state.stepNumber + 1);
        const current = history[this.state.stepNumber];
        const squares = current.squares.slice();
        if (calculateWinner(squares) || squares[i]) {
            return;
        }
        squares[i] = this.state.xIsNext ? 'X' : 'O';
        this.setState({
            history: history.concat([{
                squares: squares,
            }]),
            stepNumber: history.length,
            xIsNext: !this.state.xIsNext,
        });
    }
    changeContents(i){
        const newContentsNumber = i;
        this.setState({
            contentsNumber: newContentsNumber
        });
    }
    jumpTo(step) {
        this.setState({
            stepNumber: step,
            xIsNext: (step % 2) === 0,
        })
    }
    renderJumbotron() {
        const history = this.state.history;
        const current = history[this.state.stepNumber];
        const winner = calculateWinner(current.squares);
        let status;
        if (winner) {
            status = 'Winner: ' + winner;
        } else {
            status = 'Next number: ' + (this.state.xIsNext ? 'X' : 'O');
        }
        const style = {
            backgroundImage: `url(${jumboUrl})`,
            backgroundPosition: 'top',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            marginBottom: 0
        };
        return (
            <Jumbotron style={style}>
                <div className="game">
                    <bootstrapContainer>
                        <Row>
                            <Col>
                                <div className="game-board">
                                    <Board
                                        squares={current.squares}
                                        onClick={(i) => this.handleClick(i)}
                                    />
                                </div>
                            </Col>
                            <Col>
                                <Paper elevation={5}>
                                    <div className="game-info">
                                        <div>
                                            <h1>k0syam website</h1>
                                            <p>{status}</p>
                                        </div>
                                    </div>
                                </Paper>
                            </Col>  
                        </Row>
                    </bootstrapContainer>
                </div>
            </Jumbotron>
        );
    }
    renderNavbar(){
        const style = {
            backgroundImage: `url(${navBarUrl})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            marginBottom: 0
        };
        return(
            <Navbar expand="lg" variant="light" bg="light" style={style}>
                <bootstrapContainer>
                    <Row>
                        <Col><Button onClick={() => this.changeContents(0)}>General</Button></Col>
                        <Col><Button onClick={() => this.changeContents(1)}>Music</Button></Col>
                        {/* <Col><Button>Works</Button></Col> */}
                        <Col><Button onClick={() => this.changeContents(2)}>Contact</Button></Col>
                    </Row>
                </bootstrapContainer>
            </Navbar>
        )
    }
    render(){
        const {contentsNumber} = this.state;
        return(
            <div>
                {this.renderJumbotron()}
                {this.renderNavbar()}
                <App contentsNumber={contentsNumber} />
            </div>
        )
    }
}

// ========================================
  
ReactDOM.render(
    <Game />,
    document.getElementById('root')
);
